import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
window.Pusher = Pusher;

const echoInit = async (knoxToken) => {
  const auth = {
    headers: {
      Authorization: `Bearer ${knoxToken}`,
      Accept: 'application/json',
    },
  };

  window.Echo = new Echo({
    broadcaster: 'pusher',
    authEndpoint: import.meta.env.VITE_API_RAW_BASE_URL + '/api-ws/broadcasting/auth',
    auth: auth,
    disableStats: true,
    key: import.meta.env.VITE_APP_PUSHER_KEY,
    cluster: import.meta.env.VITE_APP_PUSHER_CLUSTER,
    encrypted: import.meta.env.VITE_APP_PUSHER_ENCRYPTED,
    namespace: import.meta.env.VITE_APP_PUSHER_NAMESPACE,
  });
};

export default echoInit;
